import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translation files
import translationEN from './locales/en/translation.json';
import translationUR from './locales/ur/translation.json';

// Translation resources
const resources = {
  en: {
    translation: translationEN
  },
  ur: {
    translation: translationUR
  }
};

i18n
  // Detect user language
  .use(LanguageDetector)
  // Pass the i18n instance to react-i18next
  .use(initReactI18next)
  // Initialize i18next
  .init({
    resources,
    fallbackLng: 'en',
    debug: process.env.NODE_ENV === 'development',
    
    // Language detection options
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'hria-language'
    },
    
    interpolation: {
      escapeValue: false // React already escapes values
    },
    
    // React options
    react: {
      useSuspense: true
    }
  });

// Set initial direction based on language
i18n.on('languageChanged', (lng) => {
  const dir = lng === 'ur' ? 'rtl' : 'ltr';
  document.documentElement.dir = dir;
  document.documentElement.lang = lng;
  
  // Save to localStorage
  localStorage.setItem('hria-language', lng);
  localStorage.setItem('hria-direction', dir);
});

// Set initial direction
const initialLang = i18n.language;
const initialDir = initialLang === 'ur' ? 'rtl' : 'ltr';
document.documentElement.dir = initialDir;
document.documentElement.lang = initialLang;

export default i18n;

// Export utility functions
export const changeLanguage = (language: 'en' | 'ur') => {
  i18n.changeLanguage(language);
};

export const getCurrentLanguage = (): 'en' | 'ur' => {
  return i18n.language as 'en' | 'ur';
};

export const isRTL = (): boolean => {
  return i18n.language === 'ur';
};

